// Client-side mirror of the admin/functions serial-tracking helpers.
// Pure array math plus a write-through to the `productSerials/{serialNumber}`
// lookup collection, used when this app's own warehouseReservationService
// claims stock directly from the browser (mirroring the admin/functions
// reservation logic — see stockReservation.ts and admin's orderService.ts).
import { doc, serverTimestamp, Transaction } from 'firebase/firestore';
import { db } from '../pages/Firebase/Config';

const SERIAL_LOOKUP_COLLECTION = 'productSerials';

export function claimSerialsFromArray(
  availableSerials: string[] | undefined,
  count: number
): { claimed: string[]; remaining: string[] } {
  const serials = availableSerials || [];
  return {
    claimed: serials.slice(0, count),
    remaining: serials.slice(count),
  };
}

export type SerialDocStatus = 'in_stock' | 'sold' | 'returned' | 'damaged';

export interface SerialDocContext {
  productId: string;
  productName?: string;
  sku?: string;
  variantId?: string;
  variantSku?: string;
  warehouseId: string;
  warehouseName?: string;
  orderId?: string;
  orderNumber?: string;
}

export function writeSerialStatus(
  transaction: Transaction,
  serialNumber: string,
  status: SerialDocStatus,
  context: SerialDocContext
): void {
  const ref = doc(db, SERIAL_LOOKUP_COLLECTION, serialNumber);
  const now = serverTimestamp();

  const data: Record<string, any> = {
    serialNumber,
    productId: context.productId,
    warehouseId: context.warehouseId,
    status,
  };
  if (context.productName !== undefined) data.productName = context.productName;
  if (context.sku !== undefined) data.sku = context.sku;
  if (context.variantId !== undefined) data.variantId = context.variantId;
  if (context.variantSku !== undefined) data.variantSku = context.variantSku;
  if (context.warehouseName !== undefined) data.warehouseName = context.warehouseName;
  if (context.orderId !== undefined) data.orderId = context.orderId;
  if (context.orderNumber !== undefined) data.orderNumber = context.orderNumber;

  if (status === 'sold') {
    data.dateSold = now;
  } else if (status === 'returned' || status === 'damaged') {
    data.dateReturned = now;
  } else if (status === 'in_stock') {
    data.dateAdded = now;
  }

  transaction.set(ref, data, { merge: true });
}
